import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const MIN = 0;
const MAX = 300;
const normalize = (value) => ((value - MIN) * 100) / (MAX - MIN);

const Counter = ({ count }) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "start",
				columnGap: "16px",
			}}
		>
			<Typography
				component="span"
				sx={{ whiteSpace: "nowrap", fontSize: "14px", color: "#A6A6A6" }}
			>
				{t("address_limit")}
			</Typography>
			<Box sx={{ minWidth: "199px", width: "100%", position: "relative" }}>
				<LinearProgress
					className="limit-indicator"
					variant="determinate"
					value={normalize(count)}
				/>
				<Typography
					component="span"
					sx={{
						fontSize: "12px",
						color: "#A6A6A6",
						position: "absolute",
						right: 0,
						top: "-15px",
					}}
				>
					{count} {t("of")} {MAX}
				</Typography>
			</Box>
		</Box>
	);
};

export default Counter;
